/**
 * Created by du on 16/11/30.
 */
import React, {Component}  from 'react';
import Material from  '../Material'
import AnswerAnalysis from '../Material/AnswerAnalysis'
import Recorder from '../../Common/Recorder';
import { observer } from 'mobx-react';

@observer(['practiceStore'])
export default class SpeakingQuestion extends Component{
	saveAnswer(audioInfo){;
		const { practiceStore } = this.props;
		practiceStore.saveAnswer([{ index:0,
			answer: {audioPath: audioInfo.path, duration: audioInfo.duration}
		}]);
	}
	render(){
		const { practiceStore, question, answer_analysis , answerTime, category } = this.props
		return (
			<div>
				<Material stem={ question } categroy={category}/>
				<Recorder saveAnswer={this.saveAnswer.bind(this)} answerTime={answerTime}/>
				{ practiceStore.show.answer ?
					<AnswerAnalysis analysisAnswer={ answer_analysis } />
					: null
				}
			</div>
		)
	}
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Question/SpeakingQuestion.js
 **/